import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import { getSeekerProfile, checkProfileCompletion } from '../services/seekerProfileService';

const DashboardRedirect = ({ user, userData, loading }) => {
  const [checkingProfile, setCheckingProfile] = useState(false);
  const [itemPath, setItemPath] = useState(null);

  useEffect(() => {
    const checkJobSeekerProfile = async () => {
      if (user && userData?.userType === 'jobseeker') {
        setCheckingProfile(true);
        try {
          const result = await getSeekerProfile(user.uid);
          if (result.success && result.profile) {
            const stats = checkProfileCompletion(result.profile);
            if (stats.completionPercentage >= 80) {
              if (!userData?.paymentId) {
                // Payment incomplete — send user to profile to make payment
                setItemPath('/seeker-profile');
              } else {
                // Profile complete and payment done — go to dashboard.
                setItemPath('/dashboard/jobseeker');
              }
            } else {
              // Profile incomplete — send user to finish it
              setItemPath('/seeker-profile');
            }
          } else {
            // No profile created yet — go create one
            setItemPath('/seeker-profile');
          }
        } catch (error) {
          console.error('Error checking profile:', error);
          setItemPath('/dashboard/jobseeker'); // Fallback on error
        } finally {
          setCheckingProfile(false);
        }
      }
    };

    if (!loading && user && userData) {
      if (userData.userType === 'jobseeker') {
        checkJobSeekerProfile();
      }
    }
  }, [user, userData, loading]);

  if (loading || checkingProfile) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!userData) {
    return <LoadingSpinner />;
  }

  // Handle Job Seeker Redirection
  if (userData.userType === 'jobseeker') {
    if (itemPath) {
      return <Navigate to={itemPath} />;
    }
    return <LoadingSpinner />; // Waiting for async check
  }

  // Redirect all other user types to their specific dashboards
  switch (userData.userType) {
    case 'employer':
      return <Navigate to="/dashboard/employer" />;
    case 'superadmin':
      return <Navigate to="/superadmin/dashboard" />;
    case 'team':
      return <Navigate to="/team/dashboard" />;
    case 'agent':
      return <Navigate to="/agent/dashboard" />;
    case 'franchise':
      return <Navigate to="/franchise/dashboard" />;
    default:
      return <Navigate to="/" />;
  }
};

export default DashboardRedirect;
